import { LionIcon } from "@/components/ContactInterest";
import { BarChart3, Bell, BookOpen, Briefcase, Building2, CalendarClock, Copy, History, Home, LayoutDashboard, Mail, Megaphone, Phone, PieChart, Radio, Route, ScrollText, Settings, Star, Trophy, Upload, User, UserCheck, UserCog, Users } from "lucide-react";

export const ADMIN_NAV = [
  { section: "Steuerung", items: [
    { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/live-team", label: "Live-Team", icon: Radio },
  ]},
  { section: "Vertrieb & Funnel", items: [
    { to: "/admin/leads", label: "Leads", icon: Users },
    { to: "/admin/assigned", label: "Zugewiesene Kontakte", icon: UserCheck },
    { to: "/admin/routing", label: "Ausspielung", icon: Route },
    { to: "/admin/opportunities", label: "Chancen", icon: Briefcase },
    { to: "/admin/customers", label: "Bestandskunden", icon: Building2 },
    { to: "/admin/contacted", label: "Kontaktiert", icon: History },
    { to: "/admin/duplicates", label: "Dubletten", icon: Copy },
  ]},
  { section: "Organisation", items: [
    { to: "/admin/whatsapp", label: "WhatsApp-Konfiguration", icon: Phone },
    { to: "/admin/mails", label: "Mail- & WhatsApp-Vorlagen", icon: Mail },
    { to: "/admin/employees", label: "Mitarbeiter", icon: UserCog },
    { to: "/admin/teams", label: "Teams", icon: Users },
    { to: "/admin/analytics", label: "Analytics", icon: PieChart },
    { to: "/admin/ranking", label: "Ranking", icon: Trophy },
    { to: "/admin/import", label: "Import", icon: Upload },
    { to: "/admin/historical-import", label: "Historische Vertriebsdaten", icon: History },
    { to: "/admin/notifications", label: "Benachrichtigungen", icon: Bell },
    { to: "/admin/gamification", label: "Gamification", icon: Trophy },
      { to: "/admin/settings", label: "Einstellungen", icon: Settings },
    { to: "/admin/guides", label: "Telefonleitfäden", icon: BookOpen },
    { to: "/admin/audit-log", label: "Audit-Log", icon: ScrollText },
    { to: "/admin/login-log", label: "Login-Log", icon: History, adminOnly: true },
  ]},
];
export const SHARED_WORK_MENU = [
  {to:"/m/smart",label:"Smart-Modus",icon:Route},
  {to:"/m/interesting-contacts",label:"Interessante Kontakte",icon:LionIcon},
  {to:"/m/leads",label:"Leads",icon:UserCheck},
  {to:"/m/mail-followups",label:"E-Mail-Nachfassen",icon:Mail},
  {to:"/m/prewarm-call",label:"Pre-Warm Call Modus",icon:Phone,prewarmOnly:true},
  {to:"/m/tasks",label:"Aufgaben",icon:CalendarClock},
];
export const OWNER_MENU = [
  {to:"/m/email-campaigns",label:"E-Mail-Kampagnen",icon:Megaphone,janOnly:true},
];
export const ADMIN_MENU = [{section:"Vertriebsbereich",items:[
  ...SHARED_WORK_MENU,
  ...OWNER_MENU,
  {to:"/m/home",label:"Home",icon:Home},
  {to:"/m/appointments",label:"Termine",icon:CalendarClock},
  {to:"/m/opportunities",label:"Meine Chancen",icon:Briefcase},
  {to:"/m/call",label:"Cold Call",icon:Phone},
  {to:"/m/my-contacts",label:"Meine Kontakte",icon:UserCheck},
  {to:"/m/promo",label:"Promo",icon:Megaphone},
  {to:"/m/referrals",label:"Empfehlungen",icon:Star},
  {to:"/m/performance",label:"Meine Analytics",icon:BarChart3},
  {to:"/m/career",label:"Meine Karriere",icon:Trophy},
  {to:"/m/ranking",label:"Ranglisten",icon:BarChart3},
  {to:"/m/profile",label:"Mein Profil",icon:User}
]},...ADMIN_NAV];


